import { Container, Row, Col } from "react-bootstrap";
import {  FaInstagram, FaTiktok, FaMapMarkerAlt, FaPhone, FaClock } from "react-icons/fa";
import qr from "../assets/qr.png";
import { colors } from "../utils/Colors";

const Footer = () => {
  return (
    <footer style={{ backgroundColor: colors.PRIMARY }} className="text-white py-5">
      <Container>
        <Row className="justify-content-between">
       
          <Col lg={3} md={6} className="mb-4">
            <div className="footer-section">
              <h5 className="fw-bold mb-3 border-bottom pb-2" style={{ borderColor: colors.SECONDARY }}>
                Contact Information
              </h5>
              <div className="footer-item mb-2">
                <FaPhone className="me-2" style={{ color: colors.SECONDARY }} />
                <div>
                  <div className="fw-semibold">Manager:</div>
                  <div className="ms-3">0315-5530667</div>
                </div>
              </div>
              <div className="footer-item mb-2">
                <FaPhone className="me-2" style={{ color: colors.SECONDARY }} />
                <div>
                  <div className="fw-semibold">Support:</div>
                  <div className="ms-3">0332-9911223</div>
                </div>
              </div>
              <div className="footer-item mb-3">
                <FaPhone className="me-2" style={{ color: colors.SECONDARY }} />
                <div>
                  <div className="fw-semibold">Office:</div>
                  <div className="ms-3">0332-5412237</div>
                </div>
              </div>
              {/* <div className="footer-item">
                <FaEnvelope className="me-2" style={{ color: colors.SECONDARY }} />
                <div className="ms-3">info@ronaqmarquee.com</div>
              </div> */}
            </div>
          </Col>

      
          <Col lg={3} md={6} className="mb-4 text-center">
            <div className="footer-section">
              <h5 className="fw-bold mb-3 border-bottom pb-2" style={{ borderColor: colors.SECONDARY }}>
                Quick Links
              </h5>
              <div className="mb-3">
                <img 
                  src={qr} 
                  alt="QR Code Location" 
                  className="img-fluid" 
                  style={{ 
                    maxHeight: '120px', 
                    border: '3px solid white',
                    borderRadius: '8px',
                    padding: '5px',
                    
                  }} 
                />
                <div className="fw-semibold mt-2" >
                  SCAN FOR LOCATION
                </div>
              </div>
              <div className="footer-item">
                <FaMapMarkerAlt className="me-2"  />
                <div className="small">
                  Main NUST Double Road,<br />
                  OPP. Gate # H13, Islamabad
                </div>
              </div>
            </div>
          </Col>

         
          <Col lg={3} md={6} className="mb-4">
            <div className="footer-section">
              <h5 className="fw-bold mb-3 border-bottom pb-2" style={{ borderColor: colors.SECONDARY }}>
                Connect With Us
              </h5>
              
             
              <div className="mb-4">
                <div className="social-icons d-flex justify-content-center justify-content-lg-start gap-3 mb-3">
                  {/* <a 
                    href="https://facebook.com/ronaq.banquets.is" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-icon"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <FaFacebookF />
                  </a> */}
                  <a 
                    href="https://instagram.com/ronaq.banquets.is" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-icon"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <FaInstagram />
                  </a>
                  <a 
                    href="https://tiktok.com/@ronaq.banquets.is" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-icon"
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <FaTiktok />
                  </a>
                </div>
                <div className="text-center text-lg-start">
                  <span className="fw-semibold">@ronaq.banquets.is</span>
                </div>
              </div>

             
              <div>
                <h6 className="fw-bold mb-2">
                  <FaClock className="me-2" style={{ color: colors.SECONDARY }} />
                  Opening Hours
                </h6>
                <div className="small">
                  <div className="d-flex justify-content-between">
                    <span>Monday - Friday</span>
                    <span>9:00 AM - 11:00 PM</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Saturday</span>
                    <span>9:00 AM - 12:00 AM</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Sunday</span>
                    <span>9:00 AM - 11:00 PM</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        
        <Row>
          <Col xs={12}>
            <div className="text-center pt-4 mt-3 border-top" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
              <p className="mb-0">
                &copy; {new Date().getFullYear()} RONAQ Banquet & Marquee. All rights reserved.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <style jsx="true">{`
        .footer-section {
          height: 100%;
        }
        
        .footer-item {
          display: flex;
          align-items: flex-start;
        }
        
        .hover-link {
          transition: all 0.3s ease;
          position: relative;
          padding-left: 5px;
        }
        
        .hover-link:hover {
          color: ${colors.SECONDARY} !important;
          padding-left: 10px;
        }
        
        .hover-link:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 2px;
          background-color: ${colors.SECONDARY};
          transition: width 0.3s ease;
        }
        
        .hover-link:hover:before {
          width: 5px;
        }
        
        .social-icon:hover {
          background-color: ${colors.SECONDARY} !important;
          transform: translateY(-3px);
          color: #000 !important;
        }
        
        /* Responsive styles */
        @media (max-width: 768px) {
          .text-center-mobile {
            text-align: center !important;
          }
          
          .footer-item {
            justify-content: center;
            text-align: center;
          }
          
          .social-icons {
            justify-content: center !important;
          }
          
          .footer-section h5 {
            text-align: center;
          }
        }
        
        @media (max-width: 576px) {
          .footer-section {
            margin-bottom: 2rem;
          }
          
          .border-bottom {
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;